import { Moon, Sun } from "lucide-react";

import { useThemeStore } from "@/store/theme-store";

/**
 * Icon-only theme toggle, sized to match other top-bar controls.
 *
 * The two icons are stacked and crossfaded with a rotation so the
 * transition reads as a single rotating element rather than two
 * fading icons. Tooltip text describes the *next* state to match the
 * intent of clicking, which is the convention most chrome apps use.
 */
export function ThemeToggle() {
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);
  const isDark = theme === "dark";
  const tooltip = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <button
      type="button"
      data-cy="theme-toggle"
      onClick={toggleTheme}
      title={tooltip}
      aria-label={tooltip}
      className="relative inline-flex h-8 w-8 items-center justify-center rounded-md text-foreground-on-chrome hover:bg-nav-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
    >
      <Sun
        size={16}
        className={[
          "absolute transition-all duration-300",
          isDark
            ? "rotate-0 scale-100 opacity-100"
            : "-rotate-90 scale-0 opacity-0",
        ].join(" ")}
        aria-hidden="true"
      />
      <Moon
        size={16}
        className={[
          "absolute transition-all duration-300",
          isDark
            ? "rotate-90 scale-0 opacity-0"
            : "rotate-0 scale-100 opacity-100",
        ].join(" ")}
        aria-hidden="true"
      />
    </button>
  );
}
